/**
 * @fileoverview GET handler for the "/app_settings/all_tags" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";

import { appSettingsAllTags } from "./constants";
import type { AppSettingsAllTagsResult } from "./types";

export const getAppSettingsAllTags = reactQueryFetcherAdapter(
  appSettingsAllTags,
  (signal: AbortSignal, appGroupId: string): Promise<AppSettingsAllTagsResult> => {
    return fetch("/app_settings/all_tags", "GET", { app_group_id: appGroupId }, { signal });
  }
);
